@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/flexbox-helpers.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  --copy-to-clipboard-align-items: center;
  background: var(--white-layout-301-level-0-elevation);

  &::part(copy-to-clipboard) {
    --btn-padding: 0 0 0 calc(var(--spacer) / 2);
  }
}

.wrapper {
  flex-direction: column;
}

.early-access-container {
  background-color: var(--blue-layout-101-background);
  padding: calc(var(--spacer) / 2 - 2px) calc(var(--spacer) * 2);
  text-transform: uppercase;
  gz-title {
    color: var(--black-layout-700-primary);
  }
}

.network-header {
  display: flex;
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  align-items: center;
}

gz-push-body-layout {
  --expanded-width: 300px;

  &::part(header) {
    margin-bottom: var(--spacer);
  }

  &::part(sideNav) {
    overflow: hidden;
    padding: 4px calc(var(--spacer) / 2);
  }

  &::part(sideNav-content) {
    height: 100%;
  }

  .network-sidenav {
    padding-left: var(--spacer);
    padding-bottom: calc(var(--spacer) / 2);
    height: 99%;

    gz-toggle {
      height: 32px;
      display: flex;
      align-items: center;
      padding: 0 0 var(--spacer) var(--spacer);
    }

    .depth-toggle {
      font-family: var(--font-family-secondary);
    }
  }
}

.network {
  &.push-body {
    height: 100%;
  }

  .push-body--content {
    height: 100%;
  }

  .page__header {
    flex-grow: 1;
    display: flex;
    align-items: center;
    line-height: 33px;

    .title {
      display: inline-block;
      width: fit-content;
    }
  }

  &-content,
  &-grid {
    height: 100%;
  }
}

.loading-template {
  width: 100%;
  height: 100%;

  gz-push-body-layout::part(header) {
    padding-left: calc(var(--spacer) * 1);
  }

  gz-loader[class*='title-loader'],
  gz-loader[class*='filter-loader'],
  gz-loader[class*='actions-loader'] {
    width: 240px;
  }

  gz-loader[class='icon-loader'] {
    width: 24px;
  }

  gz-loader[class='smartview-title-loader'] {
    width: 120px;
  }

  gz-progress-spinner[class='spinner-dashboard'] {
    width: auto;
  }

  .buttons-loader-container {
    width: 144px;
    justify-content: space-between;
  }

  .filter-loader-container {
    padding: calc(2.5 * var(--spacer)) calc(var(--spacer) * 2.5);
  }

  .separator {
    height: calc(var(--spacer) * 2);
    width: 1px;
    margin: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 0.5);
    background-color: var(--chart-101-pressed-dividers);
  }

  .dashboard-loading {
    height: calc(100vh - 100px);
  }

  #dashboard-toolbar {
    height: calc(var(--spacer) * 5);
    padding: 0 calc(var(--spacer) * 2.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.loading-error {
  display: none;
}

.error-text {
  color: var(--body-text-arrows-400);

  .title {
    margin-bottom: var(--spacer);
  }
}

.feedback-btn {
  margin-right: calc(var(--spacer) * 18);
  &::part(button) {
    &:hover  {
      background-color: var(--blue-layout-050-selected);
      text-decoration: none;
    }
  }
  .icon {
    font-size: 24px;
    margin-right: calc(var(--spacer) / 2);
  }
}

.feedback-toolbar {
  gz-loader[class*='title-loader'] {
    padding: calc(var(--spacer) * 1.3) 0 calc(var(--spacer) * 2.5) calc(var(--spacer) * 2.5);
  }
}

::part(label-link) {
  --wrapper-padding: 0;
  --display: inline;
}

::part(link-label) {
  color: var(--blue-layout-400-primary);
  &:hover {
    color: var(--blue-layout-301-active);
  }
}

::part(container) {
  display: inline;
}

.network-panel-content {
  flex: 2;
  overflow-y: auto;

  .accordion-slot {
    width: calc(100% - 26px);
    align-items: center;
  }

  .accordion-title {
    text-transform: uppercase;
    font-size: var(--body-size-small);
    font-weight: 600;
    color: var(--chart-300-icon-buttons);
    width: auto;
  }

  gz-accordion {
    --margin--compact-accordion: 0;

    &::part(accordionHeader) {
      padding-left: calc(var(--spacer) * 2);
    }
  }
}

.global-actions-button {
  .icon {
    margin-right: -8px;
  }
}
.header-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.d-flex {
  display: flex;
}

#globalLoading {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.grid-loader {
  display: none;
  height: 100%;
  position: relative;

  gz-loader {
    height: auto;
  }

  .loader-width {
    width: 42%;
  }

  .grid-settings-loader {
    width: 156px;
  }

  .save-loader {
    width: 200px;
  }

  .border-top {
    border-top: 1px solid var(--chart-101-pressed-dividers);
  }

  .width-auto {
    width: auto;
  }

  .divider {
    width: 1px;
    height: 20px;
    background-color: var(--chart-101-pressed-dividers);
  }
}

.is-loading {
  .network-grid {
    display: none;
  }
  .grid-loader {
    display: block;
  }
}

.loader-margin {
  margin: calc(2 * var(--spacer));
}

.loading-footer-wrapper {
  border-top: 1px solid var(--chart-101-pressed-dividers);
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: var(--white-layout-301-level-0-elevation);

  .footer-loader {
    width: 60%;
  }
}

gz-navigation-button {
  display: none;
  width: fit-content;
  height: fit-content;

  &#navButtonTop {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  &#navButtonBottom {
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
}

#pushBodySidenav,
.nav-buttons {
  width: 100%;
  display: flex;
}

@media screen and (max-width: 1325px) {
  gz-navigation-button {
    &#navButtonBottom {
      bottom: 11px;
    }
  }
}
